// What a home-page demo's video and cover are addressed by.
//
// Pure functions, no state, no DOM. Extracted so the reel and anything else that shows a demo
// build the SAME url — a second spelling of one address is a second download of one file, and
// the whole reason the chip's cover is free is that it is character-for-character the url the
// POPULAR LESSONS row already fetched.
import { apiService } from "../apiService";
import { demoPreviewSrc } from "./constants";
import { demoStartSeconds } from "../config/demoVideos";
import { storageUrl, getBlobUrl, extractThumbnailUrl } from "./thumbnailPreloader";

/** The video url for one demo, started at that lesson's own opening frame.
 *
 *  STRAIGHT TO STORAGE WHEN THE PATH IS KNOWN. `apiService.getVideoUrl` points at Cloud Run,
 *  which answers 307 and redirects to the same object in GCS: measured 0.39-0.46s to first
 *  byte against 0.17-0.19s going direct, and the first request of a session can pay a cold
 *  start on top. `storage_path` arrives with the `/meta` call HomePage already makes for all
 *  ten demos, so this costs nothing to know.
 *
 *  The API url is the fallback and it works — it is merely the slow path. Reached when meta
 *  has not landed yet, or when the server withholds the path from a signed-out visitor
 *  (WATCH_REQUIRES_ACCOUNT).
 */
export const demoVideoSrc = (item, videoId) => {
  const id = videoId || item?.job_id || item?.video_id;
  if (!id) return null;
  const direct = item?.storage_path && storageUrl(item.storage_path);
  return demoPreviewSrc(direct || apiService.getVideoUrl(id), demoStartSeconds(id));
};

/** The cover for one demo, preferring a blob the row has already cached.
 *
 *  A lesson's thumbnail is a designed cover, not a frame grab, so it is worth showing before
 *  there is any video. Resolved through the row's own two helpers in the row's own order, so
 *  this is a cache hit rather than a second request. */
export const demoPosterSrc = (item) =>
  (item && (getBlobUrl(item) || extractThumbnailUrl(item))) || null;
